import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-227" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-228" data-mp="j7yej1riid1b">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-forest-950 sm:text-4xl" data-id="element-229" data-mp="j53tp94l6q7d">
          Todo lo que incluye:
        </h2>
        <p className="mt-3 text-center text-earth-700" data-id="element-230" data-mp="1bvksn3yd902f">
          {productShortName} · {totalVolumes} tomos + {totalBonuses} bonos · <b className="text-forest-900" data-id="element-231" data-mp="16v6hhd1gxa06">{price}</b>
        </p>

        <ul className="mt-10 grid gap-x-8 rounded-xl border border-earth-200 bg-white p-6 shadow-sm shadow-earth-900/5 sm:grid-cols-2 sm:p-8" data-id="element-232" data-mp="12vpc0jm1kcv0">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-earth-100 py-3 text-sm font-semibold text-forest-950" data-id="element-233" data-mp="3nln2ymb1mzxu">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest-800" data-id="element-234" data-mp="3ie7kay8n3gef">
                <CheckIcon className="h-3.5 w-3.5 text-gold-300" aria-hidden="true" data-id="element-235" data-mp="3nbh8kakalm0o" />
              </span>
              {feature}
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-gold-500 bg-earth-800 px-6 py-5 text-center font-display text-lg font-bold leading-relaxed text-cream" data-id="element-236" data-mp="3dcry32uq73ug">
          “El mejor momento para tener este material era al inicio del año. El segundo mejor momento es hoy.”
        </blockquote>
      </div>
    </section>;
}